export enum LicenseStatus {
  PENDING_AUTHENTICATION = 0,
  ACTIVE = 1,
  EXPIRED = 2,
  INVALID = 3,
  CANCELLED = 4,
  NOT_EXPIRED = 5,
  NO_LICENSE = 6,
  NOT_AVAILABLE = 7,
}
